<template>
  <UIButton
    ref="buttonRef"
    :label="short ? undefined : 'Close'"
    :trailing="short ? XMarkIcon : undefined"
    type="button"
    variant="gray"
    fill="outlined"
    tabindex="-1"
    class="ui-button-close"
    :class="classes"
  />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { UIButton } from '@ui/buttons'
import { XMarkIcon } from '@heroicons/vue/24/outline'

type Props = {
  short?: boolean
}

const props = defineProps<Props>()

const buttonRef = useTemplateRef('buttonRef')

defineExpose({
  focus() {
    buttonRef.value?.focus()
  },
})

const classes = computed(() => ({
  'ui-button-close--short': props.short,
}))
</script>

<style>
.ui-button-close {
  @apply min-w-28;

  &--short {
    @apply min-w-0;
  }
}
</style>
